import { useState } from 'react';
import api from '@/lib/api';
import { toast } from 'sonner';
import { Link2, Loader2, Unlink } from 'lucide-react';

// "synced" chip for a merged identity, with a one-click detach so this project's copy can evolve on its own.
export function SyncBadge({ kind, entity, onDetached, compact = false }) {
  const [busy, setBusy] = useState(false);
  if (!entity?.sync_group) return null;
  const plural = kind === 'character' ? 'characters' : 'locations';
  const detach = async (e) => {
    e.stopPropagation();
    if (!window.confirm(`Detach "${entity.name}" from its synced identity? It will keep its current look but stop receiving updates from the other projects.`)) return;
    setBusy(true);
    try {
      const res = await api.post(`/workspace/${plural}/${entity.id}/unsync`);
      onDetached?.({ ...res.data, sync_group: null });
      toast.success(`${entity.name} is now independent`);
    } catch (err) { toast.error(err.response?.data?.detail || 'Could not detach'); }
    finally { setBusy(false); }
  };
  return (
    <span className="inline-flex items-center gap-1" data-testid={`sync-badge-${entity.id}`}>
      <span className="text-[9px] px-1.5 py-px rounded-full bg-[#10B981]/10 text-[#10B981] border border-[#10B981]/25 inline-flex items-center gap-1"><Link2 className="w-2.5 h-2.5" /> synced</span>
      <button data-testid={`sync-detach-${entity.id}`} onClick={detach} disabled={busy} title="Detach from synced identity"
        className={`inline-flex items-center gap-1 rounded-full border border-white/10 text-[#8A8A93] hover:text-white hover:border-white/30 disabled:opacity-50 ${compact ? 'p-0.5' : 'text-[9px] px-1.5 py-px'}`}>
        {busy ? <Loader2 className="w-2.5 h-2.5 animate-spin" /> : <Unlink className="w-2.5 h-2.5" />}{!compact && ' detach'}
      </button>
    </span>
  );
}
